import { defineWidgetSettings } from "@nexus/widget-sdk";
import { SUMMARY_BAND_CONFIG } from "@nexus/widget-kit";

/** What an author sets on the CDN comparison. */
export const settings = defineWidgetSettings({
  id: "cdnsa-cdn-comparison",
  extends: [SUMMARY_BAND_CONFIG],
});
